import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import Dashboard from "@pages/dashboard/Dashboard.jsx";
import UserManagementPage from "./pages/users/UserManagementPage";
import AdminLayout from "./components/layout/AdminLayout";
import LoginSuccess from "@pages/auth/LoginSuccess.jsx";
import LoginPendingApproval from "@pages/auth/LoginPendingApproval.jsx";
import LoginFailure from "@pages/auth/LoginFailure.jsx";
import ProtectedRoute from "@/components/layout/ProtectedRoute.jsx";
import LoginWaitingApproval from "@pages/auth/LoginWaitingApproval.jsx";
import Reprint from "@pages/reprint/Reprint.jsx";
import ErrorLog from "@pages/error-log/ErrorLog.jsx";
import AccountList from "@pages/account/AccountList.jsx";
import AccountGroupManagement from "@pages/account/AccountGroupManagement.jsx";
import DesignManagement from "@pages/design-management/DesignManagement.jsx";
import PageDesign from "@pages/design-management/page-design/PageDesign.jsx";
import CameraAngleManagement from "@pages/camera-angle-management/CameraAngleManagement.jsx";
import PhotoLayoutManagement from "@pages/photo-layout-management/PhotoLayoutManagement.jsx";
import PhotoFilterManagement from "@pages/photo-filter-management/PhotoFilterManagement.jsx";
import PhotoFrameManagement from "@pages/photo-frame-management/PhotoFrameManagement.jsx";
import MediaList from "@pages/reprint/MediaList.jsx";
import PagePresetManagement
    from "@pages/page-preset-management/PagePresetManagement.jsx";
import PagePreset
    from "@pages/page-preset-management/page-preset/PagePreset.jsx";
import BranchManagement from "@pages/branch/BranchManagement.jsx";
import Manual from "@pages/manual/Manual.jsx";

function App() {
    return (
            <Routes>
                {/* 공개 라우트 */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/loginPendingApproval" element={<LoginPendingApproval />} />
                <Route path="/loginWaitingApproval" element={<LoginWaitingApproval />} />
                <Route path="/loginSuccess" element={<LoginSuccess />} />
                <Route path="/loginFailure" element={<LoginFailure />} />

                {/* 보호된 라우트 */}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    {/* Modified: 2025-01-27 [현재 시간 추가 필요] - Temporarily hide dashboard */}
                    {/* <Route index element={<Dashboard />} /> */}
                    {/* <Route path="dashboard" element={<Dashboard />} /> */}
                    <Route index element={<Navigate to="/manual" replace />} />
                    <Route path="users" element={<UserManagementPage />} />
                    <Route path="reprint" element={<Reprint />} />
                    <Route path="media-list" element={<MediaList />} />
                    <Route path="error-log" element={<ErrorLog />} />
                    <Route path="account-list" element={<AccountList />} />
                    <Route path="account-group-management" element={<AccountGroupManagement />} />
                    <Route path="branch-management" element={<BranchManagement />} />
                    <Route path="design-management" element={<DesignManagement />} />
                    <Route path="design-management/page-design" element={<PageDesign />} />
                    <Route path="camera-angle-management" element={<CameraAngleManagement />} />
                    <Route path="photo-layout-management" element={<PhotoLayoutManagement />} />
                    <Route path="photo-filter-management" element={<PhotoFilterManagement />} />
                    <Route path="photo-frame-management" element={<PhotoFrameManagement />} />
                    <Route path="page-preset-management" element={<PagePresetManagement />} />
                    <Route path="page-preset-management/page-preset" element={<PagePreset />} />
                    <Route path="manual" element={<Manual />} />
                </Route>

                {/* 기본 리다이렉트 */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
    );
}

export default App;
